import {Breadcrumbs, Btn, H5} from "../../../../../AbstractElements";
import {Card, CardBody, CardHeader, Col, Container, Modal, ModalBody, ModalFooter, ModalHeader, Row} from "reactstrap";
import React, {Fragment, useContext, useEffect, useState} from "react";
import axiosConfig from "../../../../../Config/axios";
import Loader from "../../../../../Layout/Loader";
import ButtonIcon from "../../../../../CommonElements/ButtonIcon";
import {BootstrapTabContainer, BootstrapTabContent} from "../../../../../CommonElements/BootstrapTabs";
import ExtraFieldShow from "../Component/ExtraFieldShow";
import ExtraFieldForm from "../Component/Form";
import AuthorizationContext from "../../../../../_helper/Authorization";
import type {ExtraField, ExtraFieldModel} from "../../Types/ExtraFieldTypes";
import type {AuthorizationContextType} from "../../../../../_helper/Authorization/AuthorizationTypes";

const ExtraFieldIndex = () => {
    const [loaderVisibility, setLoaderVisibility] = useState<boolean>(false);
    const [extraFieldModels, setExtraFieldModels] = useState<string[]>([]);
    const [selectedExtraField, setSelectedExtraField] = useState<ExtraField | undefined>();
    const [extraFieldModalVisibility, setExtraFieldModalVisibility] = useState<boolean>(false);
    const authContext = useContext(AuthorizationContext) as AuthorizationContextType;
    const {errorHandler} = authContext || {};

    const extraFieldModalToggle = () => {
        setExtraFieldModalVisibility(!extraFieldModalVisibility);
    }

    const getExtraFields = () => {
        setLoaderVisibility(true);
        const config = {};
        axiosConfig
            .get(`/system-core/extra-field-get-model-list`, config)
            .then((response: { data: { data: ExtraFieldModel; }; }) => {
                if (response?.data?.data) {
                    const extraFieldModelsObjects = response?.data?.data;
                    const extraFieldModelsArray: string[] = [];
                    Object.keys(extraFieldModelsObjects).map((extraFieldModelsObject) =>
                        extraFieldModelsArray.push(extraFieldModelsObjects[extraFieldModelsObject])
                    )
                    setExtraFieldModels(extraFieldModelsArray);
                }
                setLoaderVisibility(false);
            })
            .catch((exception: any) => {
                errorHandler(exception);
                setLoaderVisibility(false);
            });
    }

    const addExtraField = (extraField: ExtraField) => {
        const extraFieldModelsList = [...extraFieldModels];
        const existingExtraFieldIndex = extraFieldModelsList.findIndex(existingExtraField => {
            return existingExtraField === extraField.model;
        });
        if (existingExtraFieldIndex !== -1) {
            extraFieldModelsList[existingExtraFieldIndex] = extraField.model;
        } else {
            extraFieldModelsList.push(extraField.model);
        }
        setExtraFieldModels(extraFieldModelsList);
        extraFieldModalToggle();
    }

    useEffect(() => {
        getExtraFields();
    }, [])

    return (
        <Fragment>
            <Breadcrumbs mainTitle="ExtraField" parent="Settings" title="Extra Field"/>
            <Loader visibility={loaderVisibility}/>
            <Container fluid={true}>
                <div className="email-wrap bookmark-wrap">
                    <Row>
                        <Col>
                            <Card>
                                <CardHeader className='d-flex align-items-center justify-content-between'>
                                    <H5>Extra Fields</H5>
                                    <div>
                                        <div className='d-flex align-items-center gap-2'>
                                            <ButtonIcon attrBtn={{
                                                onClick: () => setExtraFieldModalVisibility(true)
                                            }} type={'add'} permission={'create-extra-field'}/>
                                        </div>
                                    </div>
                                </CardHeader>
                                <CardBody>
                                    <BootstrapTabContainer horizontal={false}>
                                        {extraFieldModels.map((extraFieldModel, key) => {
                                            return <BootstrapTabContent title={extraFieldModel} key={key}
                                                                        icon={'icofont icofont-dashboard'}>
                                                <ExtraFieldShow extraFieldModel={extraFieldModel}/>
                                            </BootstrapTabContent>
                                        })}
                                    </BootstrapTabContainer>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </div>
                <Modal isOpen={extraFieldModalVisibility} toggle={extraFieldModalToggle} centered>
                    <ModalHeader>
                        {selectedExtraField ? 'Update' : 'Create'} ExtraField
                    </ModalHeader>
                    <ModalBody>
                        <ExtraFieldForm callBack={addExtraField} extraField={selectedExtraField}/>
                    </ModalBody>
                    <ModalFooter>
                        <Btn attrBtn={{color: 'primary', onClick: extraFieldModalToggle}}>Close</Btn>
                    </ModalFooter>
                </Modal>
            </Container>
        </Fragment>
    )
}

export default ExtraFieldIndex;
